import type { Tag } from 'src/models/tag';

export interface TagResponse {
  id: number;
  group1_id: number;
  group2_id: number;
  group3_id: number;
  tag_name: string;
  tag_type1: string;
  tag_type2: string;
  updated_at: string;
  created_at: string;
}

export type TagIndexResponse = TagResponse[];

export const toTag = (response: TagResponse): Tag => ({
  id: response.id,
  group1Id: response.group1_id,
  group2Id: response.group2_id,
  group3Id: response.group3_id,
  tagName: response.tag_name,
  tagType1: response.tag_type1,
  tagType2: response.tag_type2,
  updatedAt: response.updated_at,
  createdAt: response.created_at,
});
